import { render, staticRenderFns } from "./HiddenHorizontalScrollbar.vue?vue&type=template&id=7936b0ab"
import script from "./HiddenHorizontalScrollbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenHorizontalScrollbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HiddenHorizontalScrollbar.vue?vue&type=style&index=0&id=7936b0ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports